import { useState, useEffect } from "react";

const CMSFormImage = (props) => {
  const {
    name,
    label,
    form,
    required,
    className,
    smallDescription,
    disabled,
    helpMessage,
  } = props;

  const initialImagePath = form.values[name];
  const initialImageURL = initialImagePath
    ? process.env.REACT_APP_BACKEND_URL + "public/" + initialImagePath
    : null;

  const [image, setImage] = useState(null);
  const [imageURL, setImageURL] = useState(initialImageURL);
  const [fileName, setFileName] = useState(
    initialImagePath && typeof form.values[name] === "string"
      ? initialImagePath?.split("/").pop() // show only the filename from path
      : "Choose file"
  );

  useEffect(() => {
    if (!image || !image.name) return;
    const objectURL = URL.createObjectURL(image);
    setImageURL(objectURL);
    setFileName(image.name);
    return () => URL.revokeObjectURL(objectURL);
  }, [image]);

  const onImageChange = (e) => {
    if (e.target && e.target.files[0]) {
      const file = e.target.files[0];
      setImage(file);
      form.setFieldValue(name, file);
    } else {
      clearImage();
    }
  };

  const clearImage = () => {
    setImage(null);
    form.setFieldValue(name, "", true);
    setImageURL(null);
    setFileName("Choose file");
    form.setFieldTouched(name, true);
  };

  return (
    <div className="form-group w-full flex flex-col relative">
      <label
        htmlFor={name}
        className={`text-[19px] lg:text-21pt text-green ${
          required ? "required" : "notRequired"
        } ${form.touched[name] && form.errors[name] ? "isInvalidText" : ""}`}
      >
        {label}
        <span className="text-16pt">{smallDescription}</span>
      </label>

      {/* Image upload container */}
      <div
        className={`w-full h-[56px] mt-1 px-3 font-mono flex items-center justify-between border bg-white text-18pt rounded-[15px]
          ${
            form.touched[name] && form.errors[name]
              ? "border-green"
              : "border-green"
          }
          focus-within:ring-2 focus-within:ring-green focus-within:ring-opacity-50
          cursor-pointer ${disabled ? "bg-gray-200 cursor-not-allowed" : ""}
          ${className ? className : ""}`}
        onClick={() => !disabled && document.getElementById(name)?.click()}
      >
        <span
          className={`max-w-[90%] truncate ${
            fileName === "Choose file" ? "text-gray-400" : ""
          }`}
        >
          {fileName}
        </span>

        {fileName && fileName !== "Choose file" && (
          <button
            type="button"
            className="text-orange text-sm"
            onClick={(e) => {
              e.stopPropagation();
              clearImage();
            }}
          >
            Clear
          </button>
        )}
      </div>

      {/* Hidden file input */}
      <input
        type="file"
        id={name}
        className="hidden"
        accept="image/*"
        onChange={onImageChange}
        onBlur={form.handleBlur}
        disabled={disabled}
      />

      {/* Preview */}
      {imageURL && (
        <img
          src={imageURL}
          alt="preview"
          className="mt-2 w-full max-h-[100px] max-w-[100px] bg-white object-contain rounded-[15px] border border-green"
        />
      )}

      {/* Error message */}
      {form.touched[name] && form.errors[name] && (
        <span className="errorMessage">
          {typeof form.errors[name] === "object"
            ? form.errors[name].message
            : form.errors[name]}
        </span>
      )}
    </div>
  );
};

export default CMSFormImage;
